exports = module.exports = require("../../../../math-wordproblems/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compare-fractions-component{font-size:.8em}", ""]);

// exports
